module.exports = __webpack_public_path__ + "img/icon-service5.cf457b50.png";